export default __webpack_public_path__ + "user-logged-in-icon-k1Y.svg";